import {
  ChangeDetectionStrategy,
  Component, HostListener,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {TranslatorService} from '../../translation/translator.service';
import {ChatbotChat} from '../state/chatbot-chat';
import {Subject} from 'rxjs';
import {throttleTime, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-chatbot-chat-messages',
  templateUrl: './chatbot-chat-messages.component.html',
  styleUrls: ['./chatbot-chat-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ChatbotChatMessagesComponent implements OnInit, OnDestroy, OnChanges {

  @Input()
    chatbotChat: ChatbotChat;
  @Input()
    mobileSidebar: boolean;

  autoscroll: boolean = true;
  showScrollButton: boolean = false;

  private scrollSubject = new Subject<Event>();
  private destroy$ = new Subject<void>();

  constructor(private translatorService: TranslatorService) {}

  ngOnInit(): void {
    this.scrollSubject.pipe(
      throttleTime(100),
      takeUntil(this.destroy$)
    ).subscribe(event => this.handleScrollEvent(event));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to chatbotChat input
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event): void {
    this.scrollSubject.next(event);
  }

  trackByChatPosition = (index: number): string => [this.chatbotChat?.chat_id, index].join(':');

  private handleScrollEvent(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target) {
      return;
    }

    const threshold = 30;
    const atBottom = target.offsetHeight + target.scrollTop >= target.scrollHeight - threshold;
    const scrollTop = target.scrollTop;

    if (atBottom) {
      if (this.autoscroll === false) {
        if (this.chatbotChat?.sending) {
          this.autoscroll = true;
        }
      }
    }
    else if (this.autoscroll === true) {
      this.autoscroll = false;
    }

    this.showScrollButton = !atBottom;
  }


  __(key: string): string {
    return this.translatorService.translate('chat.' + key);
  }

  scrollToBottom(el: HTMLElement): void {
    el.scrollIntoView({behavior: 'smooth'});
  }

}
